import Text from "ab-text";
import Link from "ab-link";
import { useEboxContext } from "ab-context-ebox";

import "./ab-card.scss";

const Card = ({
  src,
  srcSet,
  label,
  href,
  title,
  description,
  link,
  cardsLength,
}) => {
  // console.log("Card", href, link);
  const [stateEbox, dispatchEbox] = useEboxContext();
  const { itemsEbox } = stateEbox;
  const { resetEbox } = dispatchEbox;

  return (
    <div className={`card-slider${cardsLength > 3 ? " four-cards" : ""}`}>
      <a
        href={href || link?.url}
        onClick={() => {
          if (itemsEbox?.length) {
            resetEbox();
          }
        }}
      >
        <div className="image">
          <picture>
            <source srcSet={srcSet} media="(max-width: 850px)" />
            <img src={src} loading="lazy" alt={label || title} />
          </picture>
        </div>
        {label ? <Text element="h1">{label}</Text> : null}
        {title ? (
          <Text element="h1" className="title">
            {title}
          </Text>
        ) : null}

        <Text element="span" className="description">
          {description}
        </Text>
      </a>

      {link && link?.title ? (
        <Link
          prefetch={false}
          text={link?.title || "Descubrir"}
          href={link?.href || link?.url}
          target={link.target}
          style={{ width: "fit-content" }}
        />
      ) : null}
    </div>
  );
};

export default Card;
